export default "__VITE_ASSET__DS9W3tMZ__"